"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var _lodash = _interopRequireDefault(require("lodash"));

var StatePersistence = /*#__PURE__*/function () {
  function StatePersistence(storageKey, state, storage, logger) {
    (0, _classCallCheck2.default)(this, StatePersistence);
    this.storageKey = storageKey;
    this.state = state;
    this.storage = storage;
    this.logger = logger;
    this.isPersisting = false;
    this.includeBuffers = true;
    this.state.persistence = this;
  }

  (0, _createClass2.default)(StatePersistence, [{
    key: "loadStateIfExists",
    value: function () {
      var _loadStateIfExists = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var storedState;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.storageKey) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return this.storage.get(this.storageKey);

              case 4:
                storedState = _context.sent;

                if (storedState) {
                  if (this.logger) {
                    this.logger('Importing state', storedState);
                  }

                  this.state.importState(storedState);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadStateIfExists() {
        return _loadStateIfExists.apply(this, arguments);
      }

      return loadStateIfExists;
    }()
  }, {
    key: "watchStateForChanges",
    value: function watchStateForChanges() {
      var _this = this;

      if (!this.storageKey) {
        return;
      } // Throttle saving the state into storage so we don't thrash the disk


      var debouncedSaveState = _lodash.default.debounce(function () {
        if (_this.logger) {
          _this.logger('State updated, setting localStorage');
        }

        _this.storage.set(_this.storageKey, _this.state.exportState(_this.includeBuffers));
      }, 1000);

      this.state.$watch('networks', debouncedSaveState, {
        deep: true
      });
      this.state.$watch('user_settings', debouncedSaveState, {
        deep: true
      });
      var bufferWatchers = [];

      var watchBuffers = function watchBuffers() {
        var _context2;

        // Clear any previous watchers
        (0, _forEach.default)(bufferWatchers).call(bufferWatchers, function (w) {
          return w();
        });
        bufferWatchers = []; // For each buffer in a network, select all the properties we want to watch for
        // changes so that vue can compare it to the previous check. If any of them has changed
        // then the $watch()er will call debouncedSaveState().

        (0, _forEach.default)(_context2 = _this.state.networks).call(_context2, function (network) {
          var _context3, _context4;

          var bufferNames = (0, _map.default)(_context3 = network.buffers).call(_context3, function (b) {
            return b.name;
          }).join(',');
          (0, _forEach.default)(_context4 = network.buffers).call(_context4, function (buffer) {
            var unwatch = _this.state.$watch(function () {
              var val = (0, _stringify.default)([bufferNames, buffer.name, buffer.settings, buffer.joined, buffer.enabled, buffer.last_read]);
              return val;
            }, debouncedSaveState);

            bufferWatchers.push(unwatch);
          });
        });
        (0, _setTimeout2.default)(watchBuffers, 2000);
      };

      (0, _setTimeout2.default)(watchBuffers, 2000);
      this.isPersisting = true;
    }
  }, {
    key: "forgetState",
    value: function () {
      var _forgetState = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.state.resetState();
                _context5.next = 3;
                return this.storage.set(this.storageKey, null);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee2, this);
      }));

      function forgetState() {
        return _forgetState.apply(this, arguments);
      }

      return forgetState;
    }()
  }]);
  return StatePersistence;
}();

exports.default = StatePersistence;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["StatePersistence"]
window._kiwi_exports.libs.StatePersistence = exports.default ? exports.default : exports;
